
import DataTable from "react-data-table-component";
import { monthList } from '../../utilities';
import { Modal, Row, Col, Button, Card, Form } from 'react-bootstrap';
import { useState, useRef, useEffect, useContext } from "react";
import { Icon } from "../../components";
import { useApiClient } from "../../ApiService/useApiClient";
import { AppContext } from "../../context/AppContext";

const pagetitle = "Qualifications and training";
const pagetitleAddNew = "Add New";
const pagetitleUpdate = "Update";

export const tableColumns = [
  {
    name: "id",
    selector: (row) => row.agentQualification?.qualificationId,
    sortable: false,
    hide: "lg",
    omit: true,
  },
  {
    name: "Qualification",
    selector: (row) => row.qualification?.qualificationName,
    sortable: true,
  },
  {
    name: "Date Qualified",
    selector: (row) => {
      let start = new Date(row.agentQualification?.dateQualified)
      let startDateEng = String(start.getDate()).padStart(2, '0') + ' ' + monthList[start.getMonth()] + ' ' + start.getFullYear();
      return (startDateEng);
    },
    sortable: false,
  },
  {
    name: "Expiry Date",
    selector: (row) => {
      let start = new Date(row.agentQualification?.expiryDate)
      let startDateEng = String(start.getDate()).padStart(2, '0') + ' ' + monthList[start.getMonth()] + ' ' + start.getFullYear();
      return (startDateEng);
    },
    sortable: false,
  },
  {
    name: "COST (£)",
    selector: (row) => '£' + row.qualification?.cost?.toFixed(2),
    sortable: false,
  },
  {
    name: "COMPANY PAID",
    selector: (row) => '£' + row.agentQualification?.companyPaidAmt?.toFixed(2),
    sortable: false,
  },
  {
    name: "USER PAID",
    selector: (row) => '£' + row.agentQualification?.userPaidAmt?.toFixed(2),
    sortable: false,
  },
  {
    name: "certificate Reference",
    selector: (row) => row.agentQualification?.certificateReference,
    sortable: false,
  },
];

const AgentQualifations = ({ data, AgentID }) => {
  const api = useApiClient();
  const { SiteConfig } = useContext(AppContext);

  const dataFetchedRef = useRef(false);
  const [DatatoUse, setData] = useState(data);
  const [error, setError] = useState(null);
  const [selectedData, setSelectedData] = useState([]);
  const [previewModal, setPreviewModal] = useState(false);
  const [detailModal, setDetailModal] = useState(false);
  const [AddModal, setAddModal] = useState(false);
  const [SkillList, setSkillList] = useState(null);
  const modalForm = useRef(null);
  const [restrictedMode, setRestrictedMode] = useState((SiteConfig.CURRENT_USER_ROLE === "user" ? true : false));
  
  function detailSelect(obj) {
    // For both details or edit (depending on mode)
    const currentData = {
      ...selectedData,
      id: obj.agentQualification.id,
      qualificationId: obj.agentQualification.qualificationId,
      qualificationName: obj.qualification?.qualificationName || "",
      certificateReference: obj.agentQualification.certificateReference,
      companyPaidAmt: obj.agentQualification.companyPaidAmt,
      dateQualified: obj.agentQualification.dateQualified,
      expiryDate: obj.agentQualification.expiryDate,
      userPaidAmt: obj.agentQualification.userPaidAmt
    };

    setSelectedData(currentData);
    if (restrictedMode) {
      setDetailModal(true);
    } else {
      setPreviewModal(true);
    }
  }

  function closePreviewModal() {
    setPreviewModal(false);
  }

  function closeDetailModal() {
    setDetailModal(false);
  }

  function closeAddModal() {
    setAddModal(false);
  }

  function openAddModel() {
    const baseURL = "HMCareSettings/skillList/";
    api.get(baseURL)
      .then((Response) => {
        setSkillList(Response.data);
        setAddModal(true);
      }).catch(error => {
        setError(error);
        console.log({ error });
      });
  }

function formatDateDisplay(dateStr) {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  return (
    String(date.getDate()).padStart(2, '0') +
    ' ' + monthList[date.getMonth()] +
    ' ' + date.getFullYear()
  );
}

  function handleFormSubmit(event) {
    event.preventDefault();
    let certificateReference = modalForm.current.querySelector('#certificateReference').value;
    let expiryDate = modalForm.current.querySelector('#expiryDate').value;    
    let companyPaidAmt = modalForm.current.querySelector('#companyPaidAmt').value;
    let userPaidAmt = modalForm.current.querySelector('#userPaidAmt').value;

    const frmFormData = new FormData();
    frmFormData.append("Id", selectedData.id);
    frmFormData.append("QualificationId", selectedData.qualificationId);
    frmFormData.append("DateQualified", selectedData.dateQualified);
    frmFormData.append("ExpiryDate", expiryDate);
    frmFormData.append("CompanyPaidAmt", companyPaidAmt);
    frmFormData.append("UserPaidAmt", userPaidAmt);
    frmFormData.append("CertificateReference", certificateReference);

    const sURL = "HMCareStaff/staff/qualification_modify";

    api.post(sURL, frmFormData)
      .then((Response) => {
        let updatedDataObj = Response.data;
        updateState(updatedDataObj);
      }).catch(error => {
        setError(error);
      });

    setPreviewModal(false);
  }

  const updateState = (updatedData) => {
    const newState = DatatoUse.map(obj => {
      if (obj.agentQualification.id === updatedData.id) {
        const tmpObj = {
          ...obj.agentQualification,
          certificateReference: updatedData.certificateReference,
          companyPaidAmt: updatedData.companyPaidAmt,
          dateQualified: updatedData.dateQualified,
          expiryDate: updatedData.expiryDate,
          userPaidAmt: updatedData.userPaidAmt
        };
        return { ...obj, agentQualification: tmpObj };
      }
      return obj;
    });
    setData(newState);
  };

  function handleAddFormSubmit(event) {
    event.preventDefault();
    let DateQualified = modalForm.current.querySelector('#DateQualified').value;
    let ExpiryDate = modalForm.current.querySelector('#ExpiryDate').value;
    let CompanyPaidAmt = modalForm.current.querySelector('#CompanyPaidAmt').value;
    let UserPaidAmt = modalForm.current.querySelector('#UserPaidAmt').value;
    let CertificateReference = modalForm.current.querySelector('#CertificateReference').value;
    let QualificationID = modalForm.current.querySelector('#QualificationID').value;

    const frmFormData = new FormData();
    frmFormData.append("AgentId", AgentID);
    frmFormData.append("QualificationId", QualificationID);
    frmFormData.append("DateQualified", DateQualified);
    frmFormData.append("ExpiryDate", ExpiryDate);
    frmFormData.append("CompanyPaidAmt", CompanyPaidAmt);
    frmFormData.append("UserPaidAmt", UserPaidAmt);
    frmFormData.append("CertificateReference", CertificateReference);

    const sURL = "HMCareStaff/staff/qualification_add/";

    api.post(sURL, frmFormData)
      .then((Response) => {
        let updatedDataObj = Response.data;
        setData([updatedDataObj, ...DatatoUse]);
      }).catch(error => {
        setError(error);
      });

    setAddModal(false);
  }

  return (
    <>
      {!restrictedMode &&
        <span style={{ float: "right" }}>
          <Button variant="outline-primary" action="add" onClick={openAddModel}>
            <Icon name="plus"></Icon><span>{pagetitleAddNew}</span>
          </Button>
        </span>
      }

      <DataTable
        tableClassName="data-table-head-light table-responsive"
        pointerOnHover={true}
        data={DatatoUse}
        columns={tableColumns}
        striped={true}
        highlightOnHover={true}
        filterFieldName={"Service"}
        onRowClicked={(row, event) => { detailSelect(row) }}
      />

      {/* Details Modal (view only, restricted mode) */}
      {detailModal && restrictedMode &&
        <Modal show={detailModal} onHide={closeDetailModal} backdrop="static">
          <Modal.Header closeButton>
            <Modal.Title className="event-title" as="h4">Qualification Details (#{selectedData.id})</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <Row className="g-3">
                <Col xs="12"><strong>Qualification:</strong> {selectedData.qualificationName}</Col>
                <Col xs="12"><strong>Certificate Reference:</strong>  {selectedData.certificateReference}</Col>
                <Col xs="12"><strong>Date Qualified:</strong>  {formatDateDisplay(selectedData.dateQualified)}</Col>
                <Col xs="12"><strong>Expiry Date:</strong>  {formatDateDisplay(selectedData.expiryDate)}</Col>
                <Col xs="12"><strong>Company Paid (£):</strong>  {selectedData.companyPaidAmt}</Col>
                <Col xs="12"><strong>User Paid (£):</strong>  {selectedData.userPaidAmt}</Col>                
                {/* <Col xs="12"><strong>Qualification ID:</strong>  {selectedData.qualificationId}</Col> */}
              </Row>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="danger" onClick={closeDetailModal}>Close</Button>
          </Modal.Footer>
        </Modal>
      }

      {/* Edit/Update Modal (non-restricted) */}
      {previewModal && !restrictedMode &&
        <Modal show={previewModal} onHide={closePreviewModal} backdrop="static">
          <Modal.Header closeButton>
            <Modal.Title className="event-title" as="h4">Modify {pagetitle} (#{selectedData.id})</Modal.Title>
          </Modal.Header>
          <Form ref={modalForm} onSubmit={handleFormSubmit}>
            <Modal.Body>
              <div>
                <Row className="g-3">
                  <Col xs="12">
                    <Form.Group>
                      <h6 className="overline-title">Certificate Reference</h6>
                      <div className="form-control-wrap">
                        <Form.Control id="certificateReference" type="text" defaultValue={selectedData.certificateReference} placeholder="Reference" />
                      </div>
                    </Form.Group>
                  </Col>
                  <Col xs="12">
                    <Form.Group>
                      <h6 className="overline-title">Expiry Date</h6>
                      <div className="form-control-wrap">
                        <Form.Control id="expiryDate" type="text" defaultValue={selectedData.expiryDate} placeholder="Expiry Date" />
                      </div>
                    </Form.Group>                   
                  </Col>
                  <Col xs="12">
                    <Form.Group>
                      <h6 className="overline-title">Company Paid (£)</h6>
                      <div className="form-control-wrap">
                        <Form.Control id="companyPaidAmt" type="text" defaultValue={selectedData.companyPaidAmt} placeholder="Company Paid Amt" />
                      </div>
                    </Form.Group>
                  </Col>
                  <Col xs="12">
                    <Form.Group>
                      <h6 className="overline-title">User Paid (£)</h6>
                      <div className="form-control-wrap">
                        <Form.Control id="userPaidAmt" type="text" defaultValue={selectedData.userPaidAmt} placeholder="User Paid Amt" />
                      </div>
                    </Form.Group>
                  </Col>
                </Row>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="danger" onClick={closePreviewModal}>Discard</Button>
              <Button variant="primary" type="submit">{pagetitleUpdate}</Button>
            </Modal.Footer>
          </Form>
        </Modal>
      }

      {/* Add Modal (non-restricted) */}
      {AddModal && SkillList && !restrictedMode &&
        <Modal show={AddModal} onHide={closeAddModal} backdrop="static">
          <Modal.Header closeButton>
            <Modal.Title className="event-title" as="h4">{pagetitleAddNew}</Modal.Title>
          </Modal.Header>
          <Form ref={modalForm} onSubmit={handleAddFormSubmit}>
            <Modal.Body>
              <div>
                <Row className="g-3">
                  <Col xs="12">
                    <Form.Group>
                      <Col xs="12">
                        <Form.Group className="fc-category-select">
                          <Form.Label htmlFor="serviceTypes">Qualification</Form.Label>
                          <Form.Select id="QualificationID" aria-label="Default select example">
                            {SkillList.map((serv) => (
                              <option key={serv.id} value={serv.id}>{serv.qualificationName}</option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Form.Label>Date Qualified</Form.Label>
                      <div className="form-control-wrap">
                        <Form.Control id="DateQualified" type="date" defaultValue={''} placeholder="Value" />
                      </div>
                      <Form.Label>Expiry Date</Form.Label>
                      <div className="form-control-wrap">
                        <Form.Control id="ExpiryDate" type="date" defaultValue={''} placeholder="Value" />
                      </div>
                      <Form.Label>Company Paid Amount</Form.Label>
                      <div className="form-control-wrap">
                        <Form.Control id="CompanyPaidAmt" type="text" defaultValue={'0'} placeholder="0.00" />
                      </div>
                      <Form.Label>User Paid Amount</Form.Label>
                      <div className="form-control-wrap">
                        <Form.Control id="UserPaidAmt" type="text" defaultValue={'0'} placeholder="0.00" />
                      </div>
                      <Form.Label>Certificate Reference</Form.Label>
                      <div className="form-control-wrap">
                        <Form.Control id="CertificateReference" type="text" defaultValue={''} placeholder="Certificate Reference" />
                      </div>
                    </Form.Group>
                  </Col>
                </Row>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="danger" onClick={closeAddModal}>Discard</Button>
              <Button variant="primary" type="submit">{pagetitleAddNew}</Button>
            </Modal.Footer>
          </Form>
        </Modal>
      }
    </>
  );
}
export default AgentQualifations;


// import DataTable from "react-data-table-component"
// import {monthList} from '../../utilities'
// import {Modal, Row, Col,Button, Card, Form} from 'react-bootstrap'
// import { useState, useRef, useEffect, useContext } from "react";
// import {Icon} from "../../components";
// import { useApiClient } from "../../ApiService/useApiClient";
// import { AppContext } from "../../context/AppContext";

// const pagetitle = "Qualifications and training";
// const pagetitleAddNew = "Add New";
// const pagetitleUpdate = "Update";

// export const tableColumns = [
//     {
//       name: "id",
//       selector: (row) => row.agentQualification?.qualificationId,
//       sortable: false,
//       hide : "lg",
//       omit : true,

//     },
//     {
//         name: "Qualification",
//         selector: (row) => row.qualification?.qualificationName,
//         sortable: true,                
//       },

//       {
//         name: "Date Qualified",
//         selector: (row) => {
//             let start = new Date(row.agentQualification?.dateQualified)    
//             let startDateEng = String(start.getDate()).padStart(2, '0') + ' ' + monthList[start.getMonth()] + ' ' + start.getFullYear();
//             return (startDateEng)
//         },
//         sortable: false,          
//       },
//       {
//         name: "Expiry Date",
//         selector: (row) => {
//             let start = new Date(row.agentQualification?.expiryDate)    
//             let startDateEng = String(start.getDate()).padStart(2, '0') + ' ' + monthList[start.getMonth()] + ' ' + start.getFullYear();
//             return (startDateEng)
//         },
//         sortable: false,       
  
//       },

//       {
//         name: "COST (£)",
//         selector: (row) => '£' + row.qualification?.cost?.toFixed(2),
//         sortable: false,        
          
//       },

//       {
//         name: "COMPANY PAID",
//         selector: (row) => '£' + row.agentQualification?.companyPaidAmt?.toFixed(2),
//         sortable: false,
//       },
//       {
//         name: "USER PAID",
//         selector: (row) => '£' + row.agentQualification?.userPaidAmt?.toFixed(2),
//         sortable: false,
//       },
//     {
//       name: "certificate Reference",
//       selector: (row) => row.agentQualification?.certificateReference,
//       sortable: false,          
//     },  
    
//   ];



// const AgentQualifations = ({data,AgentID}) => {

//   const api = useApiClient();
//    const {SiteConfig} = useContext(AppContext);

//   const dataFetchedRef = useRef(false);
//     const [DatatoUse, setData] = useState(data);
//     const [error, setError] = useState(null);

//   const [selectedData, setSelectedData] = useState([]);
//   const [previewModal, setPreviewModal] = useState(false);
//   const [AddModal, setAddModal] = useState(false);
//   const [SkillList, setSkillList] = useState(null);
//   const modalForm = useRef(null);
//   const[restrictedMode, setRestrictedMode] = useState((SiteConfig.CURRENT_USER_ROLE=="user"?true:false));

 
//   function detailSelect(obj){


//     //console.log(obj.agentQualification)

//     const currentData = {...selectedData,
//       id:obj.agentQualification.id,
//       qualificationId:obj.agentQualification.qualificationId,
//       certificateReference:obj.agentQualification.certificateReference,
//       companyPaidAmt:obj.agentQualification.companyPaidAmt,
//       dateQualified:obj.agentQualification.dateQualified,
//       expiryDate:obj.agentQualification.expiryDate,
//       userPaidAmt: obj.agentQualification.userPaidAmt      
//       }
  
//       setSelectedData(currentData)
//       setPreviewModal(true)  
  
//   }
  
//   function closePreviewModal(){
//     setPreviewModal(false);
//     } 
  
//   function closeAddModal(){
//     setAddModal(false);
//     } 
  
//   function openAddModel(){

//    const baseURL = "HMCareSettings/skillList/";
   
//     api.get(baseURL)        
//   .then((Response)=>{
//       setSkillList(Response.data);
//       setAddModal(true);
//   }).catch(error => {
//       setError(error);     
//       console.log({error})
//   });

// //console.log(SkillList)
// //return null

//     //setAddModal(true);
//     } 
  

//     function handleFormSubmit(event){

//       event.preventDefault();
//       let certificateReference = modalForm.current.querySelector('#certificateReference').value;
//       let expiryDate = modalForm.current.querySelector('#expiryDate').value;
//       let companyPaidAmt = modalForm.current.querySelector('#companyPaidAmt').value;
//       let userPaidAmt = modalForm.current.querySelector('#userPaidAmt').value;
            
//       const frmFormData = new FormData();
//       frmFormData.append("Id", selectedData.id) 
//       frmFormData.append("QualificationId", selectedData.qualificationId) 
//       frmFormData.append("DateQualified", selectedData.dateQualified) 
//       frmFormData.append("ExpiryDate", expiryDate) 
//       frmFormData.append("CompanyPaidAmt", companyPaidAmt) 
//       frmFormData.append("UserPaidAmt", userPaidAmt) 
//       frmFormData.append("CertificateReference", certificateReference) 
         
      
// //console.log(frmFormData)


//       const sURL = "HMCareStaff/staff/qualification_modify";
    
//       api.post(sURL,frmFormData)
//       .then((Response)=>{

//           let updatedDataObj = Response.data;    
          
//           //console.log(updatedDataObj)
//          // return null

//           updateState(updatedDataObj)
          
//       }).catch(error => {
//           setError(error);     
//           //console.log({error})
//       });

//       setPreviewModal(false);

//   }   

//   const updateState = (updatedData) => {


//     //console.log(DatatoUse)
//     //return null

//     const newState = DatatoUse.map(obj => {
//         // 👇️ if id equals 2, update country property
//         if (obj.agentQualification.id === updatedData.id) {

//         const tmpObj = {...obj.agentQualification, 
//           certificateReference: updatedData.certificateReference,            
//             companyPaidAmt:updatedData.companyPaidAmt,            
//             dateQualified:updatedData.dateQualified,            
//             expiryDate:updatedData.expiryDate,            
//             userPaidAmt:updatedData.userPaidAmt 
//         };   

//         return {...obj, agentQualification : tmpObj };
//         }

//         // 👇️ otherwise return the object as is
//         return obj;
//     });
    
//     setData(newState);
        
//     };

//   function handleAddFormSubmit(event){

//        event.preventDefault();       
//        let DateQualified = modalForm.current.querySelector('#DateQualified').value;
//        let ExpiryDate = modalForm.current.querySelector('#ExpiryDate').value;
//        let CompanyPaidAmt = modalForm.current.querySelector('#CompanyPaidAmt').value;
//        let UserPaidAmt = modalForm.current.querySelector('#CompanyPaidAmt').value;
//        let CertificateReference = modalForm.current.querySelector('#CertificateReference').value;
//        let QualificationID = modalForm.current.querySelector('#QualificationID').value;

      

//       //console.log(newstatus);
      
//       const frmFormData = new FormData();            
//        frmFormData.append("AgentId", AgentID ) 
//        frmFormData.append("QualificationId", QualificationID) 
//        frmFormData.append("DateQualified", DateQualified) 
//        frmFormData.append("ExpiryDate", ExpiryDate) 
//        frmFormData.append("CompanyPaidAmt", CompanyPaidAmt) 
//        frmFormData.append("UserPaidAmt", UserPaidAmt) 
//        frmFormData.append("CertificateReference", CertificateReference) 
      
      
//        const sURL = "HMCareStaff/staff/qualification_add/";

//        api.post(sURL,frmFormData)
//       .then((Response)=>{
//           let updatedDataObj = Response.data;            
//           setData([updatedDataObj,...DatatoUse])    
//       }).catch(error => {
//           setError(error);     
//           //console.log({error})
//       });

//       setAddModal(false);

//   }   

//     return (
      
//       <>   
//       {!restrictedMode &&          
//        <span style={{float:"right"}}>      
//       <Button variant="outline-primary" action="add" onClick={openAddModel}>
//         <Icon name="plus"></Icon><span>{pagetitleAddNew}</span>
//     </Button>
//     </span>}
    
//        <DataTable tableClassName="data-table-head-light table-responsive" pointerOnHover={true} data={DatatoUse} columns={tableColumns} striped={true} highlightOnHover={true}  filterFieldName={"Service"} onRowClicked={(row,event)=>{ detailSelect(row) }} />   


// { previewModal && 
// <>
// <Modal show={previewModal} onHide={closePreviewModal} backdrop="static">
// <Modal.Header closeButton>
//   <Modal.Title className="event-title" as="h4">Modify {pagetitle} (#{selectedData.id})</Modal.Title>  
// </Modal.Header>

// <Form ref={modalForm} onSubmit={handleFormSubmit}>
// <Modal.Body>
//   <div>
//     <Row className="g-3">       
//         <Col xs="12">
//             <Form.Group>
//                 <h6 className="overline-title">certificate Reference</h6>
//                 <div className="form-control-wrap">
//                     <Form.Control id="certificateReference" type="text" defaultValue={selectedData.certificateReference} placeholder="Reference" />
//                 </div>
//             </Form.Group>
//         </Col>
//         <Col xs="12">
//             <Form.Group>
//                 <h6 className="overline-title">expiryDate</h6>
//                 <div className="form-control-wrap">
//                     <Form.Control id="expiryDate" type="text" defaultValue={selectedData.expiryDate} placeholder="Expiry Date" />
//                 </div>
//             </Form.Group>
//         </Col>
//         <Col xs="12">
//             <Form.Group>
//                 <h6 className="overline-title">Company Paid (£)</h6>
//                 <div className="form-control-wrap">
//                     <Form.Control id="companyPaidAmt" type="text" defaultValue={selectedData.companyPaidAmt} placeholder="Company Paid Amt" />
//                 </div>
//             </Form.Group>
//         </Col>
//         <Col xs="12">
//             <Form.Group>
//                 <h6 className="overline-title">User Paid (£)</h6>
//                 <div className="form-control-wrap">
//                     <Form.Control id="userPaidAmt" type="text" defaultValue={selectedData.userPaidAmt} placeholder="User Paid Amt" />
//                 </div>
//             </Form.Group>
//         </Col>
//     </Row>
//   </div>
// </Modal.Body>
// <Modal.Footer>
//     {/* <Button variant="danger" onClick={openDeleteModal}>Delete</Button>     */}
//     <Button variant="danger" onClick={closePreviewModal}>Discard</Button>
//     <Button variant="primary" type="submit">{pagetitleUpdate}</Button>
// </Modal.Footer>
// </Form>
// </Modal>
// </>
// }

// {AddModal && SkillList && !restrictedMode &&
// <Modal show={AddModal} onHide={closeAddModal} backdrop="static">
// <Modal.Header closeButton>
//   <Modal.Title className="event-title" as="h4">{pagetitleAddNew}</Modal.Title>  
// </Modal.Header>

// <Form ref={modalForm} onSubmit={handleAddFormSubmit}>
// <Modal.Body>
//   <div>
//     <Row className="g-3">       
//         <Col xs="12">
//             <Form.Group>
                
//                 <Col xs="12">
//                     <Form.Group className="fc-category-select">
//                         <Form.Label htmlFor="serviceTypes">Qualification</Form.Label>
//                         <Form.Select id="QualificationID" aria-label="Default select example">
//                             {SkillList.map((serv)=>{   
//                                 return(
//                                 <option value={serv.id}>{serv.qualificationName}</option>
//                                 )                                   
//                             })}                            
//                         </Form.Select>
//                     </Form.Group>
//                 </Col>

//                 <Form.Label htmlFor="eventTitle">Date Qualified</Form.Label>
//                 <div className="form-control-wrap">
//                     <Form.Control id="DateQualified" type="date" defaultValue={''} placeholder="Value" />
//                 </div>
//                 <Form.Label htmlFor="eventTitle">Expiry Date</Form.Label>
//                 <div className="form-control-wrap">
//                     <Form.Control id="ExpiryDate" type="date" defaultValue={''} placeholder="Value" />
//                 </div>
//                 <Form.Label htmlFor="eventTitle">Company Paid Amount</Form.Label>
//                 <div className="form-control-wrap">
//                     <Form.Control id="CompanyPaidAmt" type="text" defaultValue={'0'} placeholder="0.00" />
//                 </div>
//                 <Form.Label htmlFor="eventTitle">User Paid Amount</Form.Label>
//                 <div className="form-control-wrap">
//                     <Form.Control id="UserPaidAmt" type="text" defaultValue={'0'} placeholder="0.00" />
//                 </div>
//                 <Form.Label htmlFor="eventTitle">Certificate Reference</Form.Label>
//                 <div className="form-control-wrap">
//                     <Form.Control id="CertificateReference" type="text" defaultValue={''} placeholder="Certificate Reference" />
//                 </div>
                
//             </Form.Group>
            
//         </Col>        
//     </Row>
//   </div>
// </Modal.Body>
// <Modal.Footer>
//     <Button variant="danger" onClick={closeAddModal}>Discard</Button>
//     <Button variant="primary" type="submit">{pagetitleAddNew}</Button>
// </Modal.Footer>
// </Form>
// </Modal>
// }

//       </>    
//     )
//   }

// export default AgentQualifations